// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes shimmer-loading--z7hcF{0%{background-position:200% 0}100%{background-position:-200% 0}}.icon-circle--QbeTl{width:64px;height:64px;display:flex;align-items:center;justify-content:center;border-radius:50%}.icon-circle--QbeTl .material-symbols-outlined{font-size:39.68px}.icon-circle--QbeTl.white--ujJkY{background:#fff}.icon-circle--QbeTl.primary--wCc_t{background:#5645f5}.icon-circle--QbeTl.accent--jlWuB{background:#02d3da}.icon-circle--QbeTl.cherry--kMsPN{background:#f8558e}.icon-circle--QbeTl.small--XtY2y{width:30px;height:30px}.icon-circle--QbeTl.small--XtY2y .material-symbols-outlined{font-size:18.6px}.icon-circle--QbeTl.large--A8wbl{width:72px;height:72px}.icon-circle--QbeTl.large--A8wbl .material-symbols-outlined{font-size:44.64px}.icon-circle--QbeTl.clickable--XsL0_{transition:all .3s ease-in;cursor:pointer}.icon-circle--QbeTl.clickable--XsL0_:hover{transform:scale(1.1)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon-circle": "icon-circle--QbeTl",
	"white": "white--ujJkY",
	"primary": "primary--wCc_t",
	"accent": "accent--jlWuB",
	"cherry": "cherry--kMsPN",
	"small": "small--XtY2y",
	"large": "large--A8wbl",
	"clickable": "clickable--XsL0_",
	"shimmer-loading": "shimmer-loading--z7hcF"
};
export default ___CSS_LOADER_EXPORT___;
